import { Box, Typography } from "@mui/material";
import Input from "../../../../../../components/Input";
import { useState } from "react";
import { string } from "../../../../../../constants/string";
import ButtonComp from "../../../../../../components/Button";
import { useClaimTypeStore } from "../../../../../../store/useClaimTypeStore";
import { usePolicyNumberStore } from "../../../../../../store/usePolicyNumberStore";

type Step1FormProps = {
  handlePolicyNumberNext: (id: string) => void;
};

export default function Step1Form({ handlePolicyNumberNext }: Step1FormProps) {
  const [error, setError] = useState("");

  const claimType = useClaimTypeStore((state) => state.claimType);
  const isDeathClaim = claimType === "DEATH";

  const policyNumber = usePolicyNumberStore((state) => state.policyNumber);
  const setPolicyNumber = usePolicyNumberStore(
    (state) => state.setPolicyNumber
  );

  const handlePolicyNumberChange = (e: any) => {
    setPolicyNumber(e.target.value);
  };

  return (
    <form  onSubmit={(e) => {
    e.preventDefault();
    if (!policyNumber.trim()) {
      setError("Policy number is required.");
      return;
    }
    setError("");
    handlePolicyNumberNext(policyNumber);
  }}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        textAlign: "left",
        mt: 4,
        width: "100%",
      }}
    >
      <Box width={{xs:300,sm:500,md:600}}>
        <Typography variant="body1" fontWeight={600}>
          {string.claims.policyNumber}
        </Typography>
        <Input
          placeholder="Enter Policy Number"
          value={policyNumber}
          onChange={handlePolicyNumberChange}
        />
        {error && (
          <Typography variant="body2" color="error" mt={1}>
            {error}
          </Typography>
        )}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            py: 4,
          }}
        >
          <ButtonComp
          type="submit"
            variant="contained"
            height={40}
            fontSize="16px"
            width={200}
          >
            {isDeathClaim ? string.claims.next : "CHECK ELEGIBILITY"}
          </ButtonComp>
        </Box>
      </Box>
    </Box>
    </form>
  );
}
